import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Button } from "../../components/Button";
import { Stack } from "../../components/Stack";
import { Text } from "../../components/Text";
import logoIsola from "../../assets/logo_isola.png";
import "./style.css";
import { apartmentActions } from "../../features/apartments/reducer";
import { theme } from "../../style/theme";

export const NotFound = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleGoHome = () => {
    dispatch(apartmentActions.toggleError(false));
    dispatch(apartmentActions.toggleLoading(false));
    navigate("/", { replace: true });
  };

  return (
    <div className="notfound-container">
      <Stack flexDirection="column" alignitems="center" gap={20}>
        <img
          className="notfound-logo"
          src={logoIsola}
          alt="Isola dei Mori"
        />
        <Text
          fontSize="xxl"
          bold
          textAlign="center"
          color={theme.colors.black}
        >
          Questa pagina non esiste
        </Text>
        <Text fontSize="md" textAlign="center" color={theme.colors.black}>
          Torna alla homepage per continuare la navigazione.
        </Text>
        <Button buttonTitle="Torna alla home" onClick={handleGoHome} />
      </Stack>
    </div>
  );
};
